const STATS = ["pts", "min", "reb", "ast", "fg3m", "pra"];
const SUMMED = ["pts", "reb", "ast", "fg3m", "pra"];

function sumTotals(list, pick) {
  const out = Object.fromEntries(STATS.map((s) => [s, 0]));
  list.forEach((x) => STATS.forEach((s) => { out[s] += pick(x)?.[s] ?? 0; }));
  return out;
}

// Rotation-adjusted totals: 240 MIN per team (pregame) or actual box score totals (final).
export function TeamTotalsRow({ rows, teamTotals, game, team, subset }) {
  const included = teamTotals.filter((t) => (game === "all" || t.game_id === game) && (team === "all" || t.team_code === team));
  const visible = new Set(rows.map((r) => `${r.game_id}|${r.team}`));
  const teams = included.filter((t) => visible.has(`${t.game_id}|${t.team_code}`));
  const rotationTeams = teams.filter((t) => t.mode === "rotation");
  const actualTeams = teams.filter((t) => t.mode === "actual");
  let totals, before = null, partial, label;
  if (subset) {
    const byKey = Object.fromEntries(teams.map((t) => [`${t.game_id}|${t.team_code}`, t]));
    totals = sumTotals(rows, (r) => byKey[`${r.game_id}|${r.team}`]?.players?.[r.player_id]);
    partial = true;
    label = `${rows.length} selected players · not a full team total`;
  } else {
    totals = sumTotals(teams, (t) => t.totals);
    if (teams.some((t) => t.before)) before = sumTotals(teams, (t) => t.before || t.totals);
    partial = rotationTeams.some((t) => t.partial);
    const parts = [];
    if (rotationTeams.length) parts.push(`${rotationTeams.length} team${rotationTeams.length > 1 ? "s" : ""} · ${rotationTeams.length * 240} MIN rotation`);
    if (actualTeams.length) parts.push(`${actualTeams.length} team${actualTeams.length > 1 ? "s" : ""} · actual`);
    if (teams.some((t) => t.source === "scenario")) parts.push("admin scenario active");
    if (rotationTeams.some((t) => Object.entries(t.capped || {}).some(([k, v]) => v.uncapped - t.totals[k] > 0.5))) parts.push("team ceiling applied");
    if (rotationTeams.length) parts.push("rotation-adjusted, may differ from rows");
    label = parts.join(" · ");
  }
  const allActual = !subset && teams.length > 0 && actualTeams.length === teams.length;
  const fmt = (v, s) => ((allActual && s !== "min") || ["pts", "min", "pra"].includes(s) ? Math.round(v) : v.toFixed(1));
  return (
    <div className="psr-row psr-total" role="row" data-testid="totals-row">
      <div className="psr-player psr-total-label" role="cell">
        <div className="psr-total-title">Total</div>
        <div className="psr-total-sub" data-testid="totals-label">{label}</div>
      </div>
      {STATS.map((s) => (
        <div key={s} className={`psr-stat ${s === "min" ? "psr-min" : ""}`} role="cell" data-testid={`total-${s}`}>
          <span className="psr-metric">
            <strong>{fmt(totals[s], s)}</strong>
            {s === "min" && partial && <small className="psr-partial" data-testid="totals-partial">PARTIAL</small>}
            {before && SUMMED.concat("min").includes(s) && Math.abs(before[s] - totals[s]) > 0.05 && (
              <small className="psr-before" data-testid={`total-before-${s}`}>before {["pts", "min", "pra"].includes(s) ? Math.round(before[s]) : before[s].toFixed(1)}</small>
            )}
          </span>
        </div>
      ))}
      <div className="psr-form" role="cell" />
    </div>
  );
}
